import React, { useEffect, useState } from 'react';
import PageMeta from '../components/common/PageMeta';
import ComponentCard from '../components/common/ComponentCard';
import PageBreadcrumb from '../components/common/PageBreadCrumb';
import { settingsService } from '../services/SettingsService';
import Switch from '../components/form/switch/Switch';

export default function Settings() {
    const [downloadResultImmediately, setDownloadResultImmediately] = useState(true);
    const [defaultIncludePdfOnReport, setDefaultIncludePdfOnReport] = useState(false);

    useEffect(() => {
        const settings = settingsService.getSettings();
        setDownloadResultImmediately(settings.downloadResultImmediately ? settings.downloadResultImmediately : true);
        setDefaultIncludePdfOnReport(settings.defaultIncludePdfOnReport ? settings.defaultIncludePdfOnReport : false);
    }, []);

    const handleDownloadToggleChange = (checked: boolean) => {
        setDownloadResultImmediately(checked);
        settingsService.updateSetting('downloadResultImmediately', checked);
    };

    const handleIncludePdfToggleChange = (checked: boolean) => {
        setDefaultIncludePdfOnReport(checked);
        settingsService.updateSetting('defaultIncludePdfOnReport', checked);
    };

    return (
        <>
            <PageMeta
                title="Settings"
                description="Set settings for the application"
            />
            <PageBreadcrumb pageTitle="Settings" />
            <div className="space-y-6">
                <ComponentCard title="App Settings">
                    <div className="space-y-4">
                        <div className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-lg">
                            <div>
                                <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                                    Download Result Immediately
                                </h3>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    Immediately download the processed result after drop
                                </p>
                            </div>
                            <Switch
                                label="Download immediately"
                                defaultChecked={downloadResultImmediately}
                                onChange={handleDownloadToggleChange}
                            />
                        </div>

                        <div className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 rounded-lg">
                            <div>
                                <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                                    Include PDF in Reports by Default
                                </h3>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    When reporting issues, include the original PDF by default
                                </p>
                            </div>
                            <Switch
                                label="Include PDF by default"
                                defaultChecked={defaultIncludePdfOnReport}
                                onChange={handleIncludePdfToggleChange}
                            />
                        </div>
                    </div>
                </ComponentCard>
            </div>
        </>
    );
}
